import enviro from 'enviro';
import { createTracker } from 'usage-tracker';
import { CRM, SETTINGS, LISTS, TASKS, CRM_TRACKER_NAMESPACE, SETTINGS_TRACKER_NAMESPACE, LISTS_TRACKER_NAMESPACE, TASKS_TRACKER_NAMESPACE, PLAYBOOKS_TRACKER_NAMESPACE } from '../constants/namespaces';
import { setPrimaryTracker } from 'usage-tracker-container';
import once from '../utils/once';
import { getTracker as getListsTracker, getTrackerSendImmediate as getListsTrackerSendImmediate } from '../loggers/ListsLogger';
import { getTracker as getSettingsTracker, getTrackerSendImmediate as getSettingsTrackerSendImmediate } from '../loggers/SettingsLogger';
import { getTracker as getTasksTracker, getTrackerSendImmediate as getTasksTrackerSendImmediate } from '../trackers/TasksTracker';
import { CRM_USAGE_TRACKER_EVENT_NAME_MAP } from '../constants/eventNames';
const TRACKER = 'tracker';
const SEND_IMMEDIATE = 'trackerSendImmediate';
export const getTracker = once(() => {
  return createTracker({
    properties: {
      namespace: CRM
    },
    onError(err) {
      console.error(err);
    },
    lastKnownEventProperties: ['screen', 'subscreen'],
    debug: () => enviro.debug('customer-data-tracker'),
    standalone: true
  });
});
const getTrackerSendImmediate = once(() => getTracker().clone({
  bypassPool: true
}));
export const trackerNamespaces = [CRM, SETTINGS, LISTS, TASKS];
export const getTrackers = once(() => {
  return {
    [CRM]: {
      [TRACKER]: getTracker,
      [SEND_IMMEDIATE]: getTrackerSendImmediate
    },
    [SETTINGS]: {
      [TRACKER]: getSettingsTracker,
      [SEND_IMMEDIATE]: getSettingsTrackerSendImmediate
    },
    [LISTS]: {
      [TRACKER]: getListsTracker,
      [SEND_IMMEDIATE]: getListsTrackerSendImmediate
    },
    [TASKS]: {
      [TRACKER]: getTasksTracker,
      [SEND_IMMEDIATE]: getTasksTrackerSendImmediate
    }
  };
});
const legacyTrackerNamespaceMap = {
  [TASKS]: TASKS_TRACKER_NAMESPACE,
  [CRM]: CRM_TRACKER_NAMESPACE,
  [SETTINGS]: SETTINGS_TRACKER_NAMESPACE,
  [LISTS]: LISTS_TRACKER_NAMESPACE
};
const CrmUsageTracker = {
  trackerProperties: undefined,
  init: properties => {
    if (properties) CrmUsageTracker.trackerProperties = properties;
    setPrimaryTracker(getTracker());
  },
  track: (evt, evtData, options = {}) => {
    const {
      sendImmediate = false,
      namespace = CRM
    } = options;
    const tracker =
    // @ts-expect-error needs narrower type
    getTrackers()[namespace][sendImmediate ? SEND_IMMEDIATE : TRACKER]();
    if (CrmUsageTracker.trackerProperties) {
      tracker.setProperties(CrmUsageTracker.trackerProperties);
    }
    const trackerNamespace = legacyTrackerNamespaceMap[namespace];
    if (!trackerNamespace) {
      tracker.track(evt, evtData);
      return;
    }
    const eventNameMap = CRM_USAGE_TRACKER_EVENT_NAME_MAP[namespace];
    const eventName = (eventNameMap === null || eventNameMap === void 0 ? void 0 : eventNameMap[evt]) || evt;

    // Special case for playbook
    if (evt === 'playbookInteraction') {
      tracker.track(PLAYBOOKS_TRACKER_NAMESPACE, evt, evtData);
      return;
    }
    tracker.track(trackerNamespace, eventName, evtData);
  }
};
export default CrmUsageTracker;